<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Categorías</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="exportar" type="button" class="btn-success">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <k-table
      :filterStatus="filterStatus"
      @crear="crear"
      :createButton="createButton"
      :editButton="false"
      :deleteButton="false"
      ref="listaCategorias"
      @seleccionar="seleccionar"
      :path="url + '/categorias/search'"
      :columns="[
            {
                display : 'Código',
                value : 'codigo'
            },
            {
                display : 'Nombre',
                value : 'nombre'
            },
            {
                display : 'Descripción',
                value : 'descripcion'
            },
            {
                display : 'Fecha de creación',
                value : 'created_at'
            },
            {
                display : 'Fecha de modificación',
                value : 'updated_at'
            }
        ]"
    ></k-table>
    <modal :width="'80%'" height="auto" :scrollable="true" name="categoria">
      <categoria :searchButton="searchButton" @created="createdCategoria"></categoria>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    createButton: {
      type: Boolean,
      required: false,
      default: true
    },
    filterStatus: {
      type: Boolean,
      required: false,
      default: true
    },
    searchButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      currentIndex: -1,
      url: url
    };
  },
  methods: {
    exportar: function() {
      let form = this.$refs.listaCategorias.form;
      window.open(
        url +
          "/categorias/search?exportar=S&status=" +
          form.status +
          "&search=" +
          form.search
      );
    },
    seleccionar: function(currentCategoria) {
      this.$emit("selected", currentCategoria);
    },
    crear: function() {
      this.$modal.show("categoria");
    },
    createdCategoria: function(categoria) {
      this.$refs.listaCategorias.actualizarLista(categoria);
      this.$modal.hide("categoria");
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/categorias/ListaCategorias.vue